import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { attachmentsApi, DeleteAttachmentParams } from '../api/attachmentsApi';

interface UseDeleteAttachmentOptions {
  onSuccess?: (data: boolean, variables: DeleteAttachmentParams) => void;
  onError?: (error: Error) => void;
}

export const useDeleteAttachment = (
  options: UseDeleteAttachmentOptions = {}
): UseMutationResult<boolean, Error, DeleteAttachmentParams> => {
  const { onSuccess: onSuccessCallback, onError: onErrorCallback } = options;

  return useMutation({
    mutationFn: ({ issueKey, attachmentId }: DeleteAttachmentParams) =>
      attachmentsApi.deleteAttachment({ issueKey, attachmentId }),

    onSuccess: (data, variables) => {
      if (onSuccessCallback) {
        onSuccessCallback(data, variables);
      }
    },
    onError: (error: Error) => {
      console.error('Error deleting attachment:', error);
      if (onErrorCallback) {
        onErrorCallback(error);
      }
    }
  });
};
